import React from 'react';
import Tab from '../webcommon/header/tab/Tab';
import { withRouter } from 'react-router';
import styles from './Summary.module.scss';
import tabStyles from './TabOverride.module.scss';
import uploadImPerLotFile from './upload/uploadImPerLotFile';
import exportCommodityReport from './export/exportCommodityReport';
import viewDailyFiles from './viewDaily/viewDailyFiles';
import commodityJobsRouting from './triggerJobs/CommodityJobsRouting'





export default (withRouter(() => (
    <div className={ styles.summary }>
        <div className={ styles.header }>
            Commodity Future Report
        </div>
        <div className={ styles.tabContainer }>
            <Tab
                rememberLastTab
                styles={ tabStyles }
                tabs={ [
                    {
                        title: 'Upload Monthly File',
                        path: '/imperlotUpload',
                        component: uploadImPerLotFile
                    }
                    ,{
                        title: 'View Daily Files',
                        path: '/viewDailyFiles',
                        component: viewDailyFiles
                    }
                    ,{
                        title: 'Trigger Commodity Report Jobs',
                        path: '/triggerJobs',
                        component: commodityJobsRouting
                    }
                    ,{
                        title: 'Export Commodity Report',
                        path: '/exportCommodityReport',
                        component: exportCommodityReport
                    }
                    
                ] }
            />
        </div>
    </div>
)));
